import config from "site.config";

export function formatDate(input: string): string {
  let date = new Date(input)
  let yyyy = date.getFullYear();
  let mm = date.getMonth() + 1; // Months start at 0!
  let dd = date.getDate();
  let day = ''+dd;
  let month = ''+mm;
  if (dd < 10) { day = '0' + dd;}
  if (mm < 10) { month = '0' + mm;}

  let formattedToday = day + '/' + month + '/' + yyyy;
  return formattedToday;
}

export function isActiveLink(link: string, locale, path){
  let result = false;
  if( link === path ) {
    return true;
  }

  let path_with_locale = '/'+locale+(path=='/'?'':path);
  if( link === path_with_locale ) {
    return true;
  }

    let path_parts = path.split('/');
    path_parts.forEach(path_part => {
      if( path_part !== '') {
        if ('/' + path_part === link) {
          result = true;
        }
      }
    })

  return result;
}

export function absolutePublicUrl(input: string) {
  if (config.debug)
    console.log('absoluteUrl ' + `${input}` + ' transformed into:');

  if (input.includes(`${process.env.NEXT_INTERNAL_DRUPAL_API_URL}`)) {
    if (config.debug)
      console.log(`${input}`.replace(`${process.env.NEXT_INTERNAL_DRUPAL_API_URL}`, `${process.env.NEXT_PUBLIC_DRUPAL_API_URL}`));
    return `${input}`.replace(`${process.env.NEXT_INTERNAL_DRUPAL_API_URL}`, `${process.env.NEXT_PUBLIC_DRUPAL_API_URL}`);
  }
  else if (input.toLowerCase().startsWith("http")) {
    if (config.debug)
      console.log(`${input}`);
    return `${input}`
  }
  else if (input.indexOf('/') == 0) {
    if (config.debug)
      console.log(`${process.env.NEXT_PUBLIC_DRUPAL_API_URL}${input}`);
    return `${process.env.NEXT_PUBLIC_DRUPAL_API_URL}${input}`
  }
  if (config.debug)
    console.log(`${process.env.NEXT_PUBLIC_DRUPAL_API_URL}/${input}`);
  return `${process.env.NEXT_PUBLIC_DRUPAL_API_URL}/${input}`
}

export function absoluteInternalUrl(input: string) {
  if (config.debug)
    console.log('absoluteUrl ' + `${input}` + ' transformed into:');

  if (input.includes(`${process.env.NEXT_PUBLIC_DRUPAL_API_URL}`)) {
    if (config.debug)
      console.log(`${input}`.replace(`${process.env.NEXT_PUBLIC_DRUPAL_API_URL}`, `${process.env.NEXT_INTERNAL_DRUPAL_API_URL}`));
    return `${input}`.replace(`${process.env.NEXT_PUBLIC_DRUPAL_API_URL}`, `${process.env.NEXT_INTERNAL_DRUPAL_API_URL}`);
  }
  else if (input.toLowerCase().startsWith("http")) {
    if (config.debug)
      console.log(`${input}`);
    return `${input}`
  }
  else if (input.indexOf('/') == 0) {
    if (config.debug)
      console.log(`${process.env.NEXT_INTERNAL_DRUPAL_API_URL}${input}`);
    return `${process.env.NEXT_INTERNAL_DRUPAL_API_URL}${input}`
  }
  if (config.debug)
    console.log(`${process.env.NEXT_INTERNAL_DRUPAL_API_URL}/${input}`);
  return `${process.env.NEXT_INTERNAL_DRUPAL_API_URL}/${input}`
}

export function processHTML(html: string) {
  return html.split(`src="/`).join(`src="${process.env.NEXT_PUBLIC_DRUPAL_API_URL}/`);
}

export function filterTagsFromCampaigns(input) {
  const tags_lists = input.map((project) => {
    return project.field_tags;
  });

  let return_tags = [];
  tags_lists.map((tag_list)=>{
    tag_list.map((tag)=>{
      return_tags.push({id:tag.id, name: tag.name});
    })
  })
  const tags = Array.from(new Set(return_tags.map(s => s.id)))
      .map(id => {
        return {
          id: id,
          name: return_tags.find(s => s.id == id).name
        };
      });

  return tags;
}

export function isRelative(url: string) {
  return !new RegExp("^(?:[a-z]+:)?//", "i").test(url)
}
